import { useCommunity, useCommunityId } from '@/hooks/communities';
import Layout from '@/layouts/Layout';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout')({
  component: Layout,
  loader: async ({ context: { queryClient } }) => {
    const data = await useCommunityId.ensureQueryData(queryClient);
    const community = await useCommunity.ensureQueryData(queryClient, data?.communityId);
    return { communityName: community?.name, faviconUrl: community?.favicon?.url };
  },
  head: ({ loaderData }) => ({
    meta: [{ title: loaderData?.communityName ?? 'Loading' }],
    links: [{ rel: 'icon', href: loaderData?.faviconUrl ?? '/favicon.ico' }],
  }),
});
